export default __webpack_public_path__ + "static/media/b.b857ebcbfa63dec9d68ea6d28a9f9312.mp3";